import clsx from "clsx";
import { TdHTMLAttributes } from "react";

export interface TableCellProps extends TdHTMLAttributes<HTMLTableCellElement> {
  children: React.ReactNode;
  /**
   * Se habilitado, o conteúdo da célula não será envolvido em uma tag `<p>`.
   */
  unwrapped?: boolean;
}

export const TableCell = ({ children, className, unwrapped, ...props }: TableCellProps) => {
  return (
    <td
      className={clsx(
        "border [&:not(:last-child)]:border-r-0 border-background-secondary px-6 py-4 [&:first-child_p]:!font-bold",
        className,
      )}
      {...props}
    >
      {unwrapped ? children : <p>{children}</p>}
    </td>
  );
};
